/* global axios */
import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  // Override delete method for singular resource (no ID in URL)
  delete(params) {
    return axios.delete(this.url, { params });
  }
}

export default new NotificationSubscriptions();
